import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Secretaria, Secretario } from '../../api.service';
import { ServicoMensagemAplicacao } from '../../shared/servico-mensagem-aplicacao';
import { ServicoPortariaFerias } from '../ferias/servico-portaria-ferias';

@Component({
  selector: 'app-painel-secretarios-empregador',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './painel-secretarios-empregador.component.html'
})
export class PainelSecretariosEmpregadorComponent implements OnChanges {
  @Input() empregadorId = '';
  @Output() mensagem = new EventEmitter<string>();

  secretarias: Secretaria[] = [];
  secretarios: Secretario[] = [];
  formulario: Secretario = this.servico.novoSecretario();

  constructor(
    private readonly servico: ServicoPortariaFerias,
    private readonly servicoMensagem: ServicoMensagemAplicacao
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['empregadorId']) {
      this.limpar();
      this.recarregar();
    }
  }

  recarregar() {
    if (!this.empregadorId) {
      this.secretarias = [];
      this.secretarios = [];
      return;
    }
    this.servico.listarSecretarias(this.empregadorId).subscribe({
      next: secretarias => this.secretarias = secretarias,
      error: erro => this.mensagem.emit(this.servicoMensagem.erroApi(erro, 'Nao foi possivel carregar as secretarias.'))
    });
    this.servico.listarSecretarios(this.empregadorId).subscribe({
      next: secretarios => this.secretarios = secretarios,
      error: erro => this.mensagem.emit(this.servicoMensagem.erroApi(erro, 'Nao foi possivel carregar os secretarios.'))
    });
  }

  editar(item: Secretario) {
    this.formulario = { ...item };
  }

  limpar() {
    this.formulario = this.servico.novoSecretario(this.empregadorId);
  }

  salvar() {
    if (!this.empregadorId) {
      this.mensagem.emit('Salve o empregador antes de cadastrar o secretario.');
      return;
    }
    if (!this.formulario.secretariaId || !this.formulario.nome?.trim()) {
      this.mensagem.emit('Informe secretaria e nome do secretario/secretaria.');
      return;
    }
    this.servico.salvarSecretario({
      ...this.formulario,
      empregadorId: this.empregadorId,
      nome: this.formulario.nome.trim()
    }).subscribe({
      next: () => {
        this.mensagem.emit(this.servicoMensagem.registroSalvo(!!this.formulario.id));
        this.limpar();
        this.recarregar();
      },
      error: erro => this.mensagem.emit(this.servicoMensagem.erroApi(erro, 'Nao foi possivel salvar o secretario.'))
    });
  }

  excluir(item: Secretario) {
    if (!item.id || !window.confirm('Excluir este secretario/secretaria?')) {
      return;
    }
    this.servico.excluirSecretario(item.id).subscribe({
      next: () => {
        this.mensagem.emit(this.servicoMensagem.registroExcluido());
        if (this.formulario.id === item.id) {
          this.limpar();
        }
        this.recarregar();
      },
      error: erro => this.mensagem.emit(this.servicoMensagem.erroApi(erro, 'Nao foi possivel excluir o secretario.'))
    });
  }
}
